// removed by extract-text-webpack-plugin
module.exports = {"tableFixed":"LargeTable__tableFixed","scrollable":"LargeTable__scrollable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeTable/LargeTable.scss
// module id = ./src/components/LargeTable/LargeTable.scss
// module chunks = 2